export default __webpack_public_path__ + "static/realWorldImg1-bfbb99b2be59c1deb0cd1d5f1715f720.webp";